// SegmentInitializer.tsx
/* eslint-disable */
import { useEffect } from "react";

declare global {
  interface Window {
    analytics: any;
  }
}

const SegmentInitializer: React.FC = () => {
  useEffect(() => {
    const env = import.meta.env.VITE_APP_ENV;
    let writeKey = import.meta.env.VITE_SEGMENT_WRITE_KEY as string;

    if (env === "development") {
      // Ignore for dev - dummykey
      writeKey = "Dummy Key";
    }

    if (!writeKey) {
      console.error("Segment write key is missing");
      return;
    }

    (function () {
      const analytics = (window.analytics = window.analytics || []);
      if (!analytics.initialize) {
        if (analytics.invoked) {
          window.console &&
            console.error &&
            console.error("Segment snippet included twice.");
        } else {
          analytics.invoked = true;
          analytics.methods = [
            "trackSubmit",
            "trackClick",
            "trackLink",
            "trackForm",
            "pageview",
            "identify",
            "reset",
            "group",
            "track",
            "ready",
            "alias",
            "debug",
            "page",
            "once",
            "off",
            "on",
          ];
          analytics.factory = function (method: string) {
            return function () {
              const args = Array.prototype.slice.call(arguments);
              args.unshift(method);
              analytics.push(args);
              return analytics;
            };
          };
          for (let i = 0; i < analytics.methods.length; i++) {
            const method = analytics.methods[i];
            analytics[method] = analytics.factory(method);
          }
          analytics.load = function (key: string) {
            const script = document.createElement("script");
            script.type = "text/javascript";
            script.async = true;
            script.src =
              "https://cdn.segment.com/analytics.js/v1/" +
              key +
              "/analytics.min.js";
            const firstScript = document.getElementsByTagName("script")[0];
            firstScript.parentNode!.insertBefore(script, firstScript);
          };
          analytics.SNIPPET_VERSION = "4.1.0";
          analytics.load(writeKey);
          analytics.page();
        }
      }
    })();
  }, []);

  return null;
};

export default SegmentInitializer;
